import { c as _c } from "react/compiler-runtime";
import { Stack } from '@mui/material';
import { ScrollableContent } from '@/components/scroll/scrollableContent';
import { ScrollableWrapper } from '@/components/scroll/scrollableContext';
import { ScrollableHeader } from '@/components/scroll/scrollableHeader';
import { pluralize } from '@/utils/string';
import { SelectedItemsBody } from './selectedItemsBody';
import { SelectedItemsHeader } from './selectedItemsHeader';
export const SelectedItemsBox = t0 => {
  const $ = _c(15);
  const {
    items,
    entityType,
    renderItem,
    itemKey,
    onRemove,
    clearAll
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      padding: "0 24px 12px"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== entityType || $[2] !== items.length) {
    t2 = items.length === 1 ? entityType : pluralize(entityType);
    $[1] = entityType;
    $[2] = items.length;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = `${items.length} ${t2} added`;
  let t4;
  if ($[4] !== clearAll || $[5] !== t3) {
    t4 = <ScrollableHeader hideBorderWhenOnTop={true}><Stack sx={t1}><SelectedItemsHeader title={t3} clearAll={clearAll} /></Stack></ScrollableHeader>;
    $[4] = clearAll;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== itemKey || $[8] !== items || $[9] !== onRemove || $[10] !== renderItem) {
    t5 = <ScrollableContent><SelectedItemsBody items={items} renderItem={renderItem} itemKey={itemKey} onRemove={onRemove} /></ScrollableContent>;
    $[7] = itemKey;
    $[8] = items;
    $[9] = onRemove;
    $[10] = renderItem;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t4 || $[13] !== t5) {
    t6 = <Stack className="overflow-hidden"><ScrollableWrapper>{t4}{t5}</ScrollableWrapper></Stack>;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
};